import DataApi, { crmAuthHeaders } from "./DataApi";
import axios from "axios";

class EmailApi extends DataApi {
  constructor() {
    super("email");
    this.baseUrl = `${this.baseUrl}`;
  }

  // Send email
  async sendEmail(emailData) {
    try {
      const response = await axios.post(`${this.baseUrl}/send`, emailData, {
        headers: {
          ...crmAuthHeaders(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error sending email:", error);
      throw error;
    }
  }

  // Send email with attachments (FormData)
  async sendEmailWithAttachments(formData) {
    try {
      const response = await axios.post(`${this.baseUrl}/send`, formData, {
        headers: {
          ...crmAuthHeaders(),
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error sending email with attachments:", error);
      throw error;
    }
  }

  // Get email templates for an object
  async getEmailTemplates(objectName = null) {
    try {
      const url = objectName
        ? `${this.baseUrl}/templates?objectName=${encodeURIComponent(objectName)}`
        : `${this.baseUrl}/templates`;
      const response = await axios.get(url, {
        headers: {
          ...crmAuthHeaders(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching email templates:", error);
      throw error;
    }
  }

  // Get Email Campaign templates (type or object_name)
  async getEmailCampaignTemplates(objectName = null) {
    try {
      const baseUrl = this.baseUrl.replace('/email', '');
      const url = objectName
        ? `${baseUrl}/emailtemplate/emailcampaign?objectName=${encodeURIComponent(objectName)}`
        : `${baseUrl}/emailtemplate/emailcampaign`;
      const response = await axios.get(url, {
        headers: {
          ...crmAuthHeaders(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching Email Campaign templates:", error);
      throw error;
    }
  }

  // Get email history for a record
  async getEmailHistory(recordId, objectName) {
    try {
      const response = await this.fetchAll(`history/${objectName}/${recordId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching email history:", error);
      throw error;
    }
  }

  // Save email template
  async saveEmailTemplate(templateData) {
    try {
      const response = await this.create(templateData);
      return response.data;
    } catch (error) {
      console.error("Error saving email template:", error);
      throw error;
    }
  }

  // Get users/owners for email sending
  async getEmailUsers() {
    try {
      const response = await axios.get(`${this.baseUrl}/users`, {
        headers: {
          ...crmAuthHeaders(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching email users:", error);
      throw error;
    }
  }

  // Validate email address
  async validateEmail(email) {
    try {
      const response = await this.create({ email });
      return response.data;
    } catch (error) {
      console.error("Error validating email:", error);
      throw error;
    }
  }

  // Get email settings
  async getEmailSettings() {
    try {
      const response = await this.fetchAll("settings");
      return response.data;
    } catch (error) {
      console.error("Error fetching email settings:", error);
      throw error;
    }
  }

  // Update email settings
  async updateEmailSettings(settings) {
    try {
      const response = await this.update(settings, "settings");
      return response.data;
    } catch (error) {
      console.error("Error updating email settings:", error);
      throw error;
    }
  }

  // Send bulk email
  // Send bulk email
  async sendBulkEmail(bulkEmailData) {
    try {
      const response = await this.post('send-bulk', bulkEmailData);
      return response.data;
    } catch (error) {
      console.error("Error sending bulk email:", error);
      throw error;
    }
  }

  // Get email statistics
  async getEmailStats(recordId, objectName) {
    try {
      const response = await this.fetchAll(`stats/${objectName}/${recordId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching email statistics:", error);
      throw error;
    }
  }

  // Track email opens/clicks
  async trackEmailActivity(trackingData) {
    try {
      const response = await this.create(trackingData);
      return response.data;
    } catch (error) {
      console.error("Error tracking email activity:", error);
      throw error;
    }
  }

  // Get users/owners for email sending
  async getEmailConfigs() {
    try {
      const response = await axios.get(`${this.baseUrl}/mail_config`, {
        headers: {
          ...crmAuthHeaders(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching email users:", error);
      throw error;
    }
  }

  // Get attachments for a record
  async getAttachments(recordId) {
    try {
      // Use the base URL from DataApi
      const baseUrl = this.baseUrl.replace('/email', '');
      const response = await axios.get(`${baseUrl}/attachments/${recordId}`, {
        headers: {
          ...crmAuthHeaders(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching attachments:", error);
      throw error;
    }
  }
}

export default EmailApi;
